import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import $ from "jquery";
import { InstantSearch, Configure } from "react-instantsearch";
import { LogAlgoliaResults } from "../algolia/logAlgoliaResults";
import { BreadCrumb } from "../../Layout/Common/breadCrumb";
import { isValidArray } from "../../Layout/Common/common";
import { SearchResultContainer } from "./searchResutlContainer";
import { SelectedFilterMobileLite } from "../algolia/selectedFilterMobile";
import { SoryByOption } from "../algolia/sortbyOption";
import { SoryByOptionMobile } from "../algolia/sortbyOptionMobile";
import { SelectedFilterLite } from "../algolia/selectedFilter";
import { FacetFilterLite } from "../algolia/facetFilter";
import { FilterContainerMobileLite } from "../algolia/filterContainerMobile";
import { GlobalContext } from "../../Context/GlobalContext";
import { useDevice } from "../../Context/hook/useDeviceType";
import {
  ApplyDisjunctiveFiltersFromUrl,
  getInitialSortByUiState,
  indexName,
  ResetFiltersOnQueryChange,
  searchClient,
  UseCaptureFacets,
  UseSearchStats,
} from "../../Layout/Common/algoliaInstantLib";
import { SearchPageResultItems } from "../algolia/searchPageResultItems";
import ShowWhenHasResults from "../algolia/algoliaResultHandler";
import { usePageTitle } from "../../utils/pageTitle";

export const PowerSearchMainLite = () => {
  const { isGridView } = useContext(GlobalContext);
  const [sideFilterClicked, setSideFilterClicked] = useState(false);
  const [facetFilters, setFacetFilters] = useState(null);
  const [searchString, setSearch] = useState("");
  const { device } = useDevice();
  const location = useLocation();
  // Derived during render instead of in an effect. `window.location.search` is not a reactive
  // value, so the old useState + useEffect pair only picked up the new query AFTER a render and
  // paint had already gone by - every Enter fired its search a frame late. useLocation() also
  // guarantees this component actually re-renders on navigation.
  const query = new URLSearchParams(location.search).get("q") || "";

  // The search term lives in the query string, which the router-level title
  // deliberately ignores, so the page sets its own.
  usePageTitle(query ? `Search: ${query}` : "Search Results");

  useEffect(() => {
    setSearch(`Search results for <b>"${query}"</b>`);
    setFacetFilters(null);
  }, [query]);

  useEffect(() => {
    if (device && device === "desktop") {
      setSideFilterClicked(true);
    } else {
      setSideFilterClicked(false);
      $(".mobile-view.search-suggestions").fadeOut("slow");
      $(".search-backdrop").removeClass("search-bg");
      $("body").removeClass("search-body");
    }
  }, [device, query]);
  return (
    <Fragment>
      <BreadCrumb data={[{ name: searchString, url: "" }]} />
      {query && (
        <InstantSearch
          searchClient={searchClient}
          indexName={indexName}
          initialUiState={getInitialSortByUiState(indexName)}
        >
          <Configure query={query} hitsPerPage={100} maxValuesPerFacet={100} />
          <LogAlgoliaResults label="search" logInProduction />
          {!isValidArray(facetFilters) && <UseCaptureFacets setFacets={setFacetFilters} />}
          <ResetFiltersOnQueryChange query={query} />
          {isValidArray(facetFilters) && <ApplyDisjunctiveFiltersFromUrl />}
          <section className="filter-popular-section">
            <div className="container-fluid container-lg">
              <SearchResultContainer search={searchString} isEbook={false} />
              <div className="row mt-3">
                <div className="col-lg-12">
                  <div className="filterHead-wrapper filterHead-wrapperWeb">
                    <div className="filterbtn-left">
                      <button
                        className="btn"
                        id="searchFilter-btn"
                        onClick={() => setSideFilterClicked(!sideFilterClicked)}
                      >
                        <span className="wes-searchfilter" />
                        {sideFilterClicked ? "Hide Filters" : "Filter"}
                      </button>
                      <p>
                        <UseSearchStats />
                      </p>
                    </div>
                    <SoryByOption indexName={indexName} />
                  </div>
                  <div className="filterHead-wrapper filterHead-wrapperMob">
                    <FilterContainerMobileLite filterItems={facetFilters} ref={null} />
                    <SoryByOptionMobile />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <ShowWhenHasResults query={query}>
                  <div className="col-lg-12">
                    <div className={`filter-product-wrapper ${sideFilterClicked ? "" : "filter-product-wrapperHide"}`}>
                      <div
                        className={`filter-wrapper filter-wrapperWeb  mt-3 ${sideFilterClicked ? "filtersWeb" : ""}`}
                      >
                        <div className="accordion filters-accordion accordion-flush" id="selectedfilterAccordion">
                          {isValidArray(facetFilters) && <SelectedFilterLite />}
                        </div>
                        <div className="accordion filters-accordion accordion-flush" id="filterAccordion">
                          <FacetFilterLite attribute={"category"} limit={30} showMore={false} sortBy={["count:desc"]} />
                          <FacetFilterLite attribute={`prodSpecs.manufacturer`} limit={30} showMore={true} />
                          {isValidArray(facetFilters) ? (
                            <Fragment>
                              {facetFilters.map((Item) => (
                                <FacetFilterLite
                                  key={Item}
                                  attribute={`prodSpecs.${Item}`}
                                  limit={30}
                                  showMore={false}
                                  sortBy={["count:desc"]}
                                />
                              ))}
                            </Fragment>
                          ) : (
                            <div className="accordion-item">loading..</div>
                          )}
                        </div>
                      </div>
                      <div
                        className={`ct-filter-product ${!sideFilterClicked ? "filterProducts" : "active"} ${
                          isGridView ? "" : "position-relative filterProducts"
                        }`}
                        style={{ width: "100%" }}
                      >
                        {isValidArray(facetFilters) && <SelectedFilterMobileLite />}
                        <div className={`row ${isGridView ? "row-spacing row-equal" : ""}`}>
                          <SearchPageResultItems />
                        </div>
                      </div>
                    </div>
                  </div>
                </ShowWhenHasResults>
              </div>
            </div>
          </section>
        </InstantSearch>
      )}
    </Fragment>
  );
};
